<template>
  <div class="thank-you">
    <div>
      <HMLogo class="logo" />
    </div>
    <div class="container">
      <div class="row align-items-center justify-content-between mt-4">
        <div class="col-12 col-md-6 order-md-1 mt-3 mt-md-0">
          <img
            class="img-fluid"
            src="https://dv05ui3l6dkej.cloudfront.net/jeni-sandy-founders-marvelous.png"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-5 order-md-0 mt-3 mt-md-0">
          <h1 class="mb-4">
            {{ $t('THANK_YOU.TITLE.WELCOME_ABOARD') }}
          </h1>
          <p
            class="mb-5"
            v-html="
              sanitize(
                $t('THANK_YOU.TEXT.WE_RE_SO_EXCITED_TO_WELCOME', {
                  mailto: teamEmail,
                })
              )
            "
          ></p>
          <HMButton color="primary" @click="setup">
            {{ $t('THANK_YOU.BUTTON.START_SETTING_UP') }}
          </HMButton>
        </div>
      </div>
    </div>
    <div class="container footer mt-5">
      <HMMadeBy />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { getConfig } from '@/web/utils/configuration';
import { sanitize } from '@/core/utils/utils';
import { errorToMessage } from '@/core/utils/errors';
import StudioOnboardingModal from './onboarding/StudioOnboardingModal';
import StudioPreparingModal from './onboarding/StudioPreparingModal';

export default Vue.extend({
  name: 'ThankYou',
  computed: {
    teamEmail() {
      return getConfig().teamEmail;
    },
  },
  data() {
    return {
      selectedIdentity: null,
      selectedUses: null,
      selectedSource: null,
      otherIdentity: null,
      otherSource: null,
    };
  },
  methods: {
    sanitize,
    async setup() {
      this.$modal.show(
        StudioOnboardingModal,
        {
          onFinish: async (role, uses, source) => {
            try {
              await this.$store.dispatch('user/updateTeacherSignupInfo', {
                identity: role,
                uses: uses.join(','),
                signup_source: source,
              });
            } catch (error) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: errorToMessage(error.response),
              });
            }
            this.$nextTick(() => {
              this.$modal.show(
                StudioPreparingModal,
                {
                  onFinish: async () => {
                    this.$router.push({ name: 'dashboard' });
                  },
                },
                {
                  classes: ['vm--inline-modal'],
                  clickToClose: false,
                },
                {}
              );
            });
          },
        },
        {
          classes: ['vm--inline-modal'],
        },
        {}
      );
    },
  },
  mounted() {
    this.selectedIdentity = this.identities[0].code;
    this.selectedUses = [this.uses[0].code];
    this.selectedSource = this.sources[0].code;
  },
});
</script>

<style lang="scss" scoped>
.logo {
  max-width: 100%;
  height: 17px;
  margin: 2rem 2rem 0 2rem;
}

.thank-you {
  display: flex;
  justify-content: space-between;
  min-height: 100vh;
  flex-direction: column;
}

.footer {
  display: flex;
  align-items: center;
  height: 48px;
}
</style>
